import * as React from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";

import { Box, Container, makeStyles } from "@material-ui/core";

import { Routes } from "Routes";

import { IQuiltConfig } from "Model/IQuiltConfig";

import { User } from "Utility/User";
import { QuiltParamsHelper } from "Utility/QuiltParamsHelper";

import { TopAppBar } from "Components/TopAppBar";

export interface IProps {
    readonly user: User;
    readonly config: IQuiltConfig;
}

const useStyles = makeStyles({
    container: {
        flexGrow: 1,
        display: "flex",
        flexDirection: "column"
    },
});

export function App(props: IProps): React.ReactElement {
    const classes = useStyles();
    const [params, setParams] = React.useState(QuiltParamsHelper.makeDefault(props.config.version));

    const routes = Routes.map((r, index) => (
        <Route exact key={index} path={r.path}>
            <r.Page user={props.user} config={props.config} params={params} setParams={setParams}/>
        </Route>
    ));

    return (
        <BrowserRouter>
            <Container fixed className={classes.container}>
                <Box mt={1} mb={1}>
                    <TopAppBar user={props.user}/>
                </Box>
                <Box display="flex" style={{ width: "100%"}} flexDirection="column" alignItems="stretch" flexGrow={1}>
                    <Switch>
                        {routes}
                        <Route path='*'>
                            <Redirect to="/" />
                        </Route>
                    </Switch>
                </Box>
            </Container>
        </BrowserRouter>
    )
}